/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, IWrapHTTPConfig } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AuthorizationForm } from '../models/authorization-form';
import { ResponseTokenDto } from '../models/response-token-dto';

@Injectable({
  providedIn: 'root',
})
export class CommonAuthApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation login
   */
  static readonly LoginPath = '/api/v1/common/auth/login';

  /**
   * Login
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private login$Response(params: {
    body: AuthorizationForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseTokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommonAuthApiService.LoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseTokenDto>;
      })
    );
  }

  /**
   * Login
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(params: {
    body: AuthorizationForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseTokenDto> {

    return this.wrapHTTPQuery(this.login$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseTokenDto>) => r.body as ResponseTokenDto)
    ), config);
  }

}
